<div class="container py-4" style="max-width: 860px">
  <!-- Hero Banner -->
  <div class="booking-hero card border-0 mb-4">
    <div class="booking-hero__content">
      <div>
        <div class="booking-hero__eyebrow">Medical Consultation</div>
        <h2 class="booking-hero__title mb-1">Create Medical Record</h2>
        <div class="booking-hero__meta">
          <span
            ><i class="bi bi-file-earmark-medical me-1 text-primary"></i>Record patient diagnosis,
            notes, and lab attachments</span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="card booking-card">
    <div class="card-header booking-card__header">
      <div>
        <div class="booking-card__eyebrow">Consultation Details</div>
        <h3 class="sub-title mb-0">Doctor Findings & Attachments</h3>
      </div>
    </div>

    <div class="card-body p-4">
      <form [formGroup]="medicalRecordForm" (ngSubmit)="submit()" novalidate>
        <div class="row g-3">
          <div class="col-md-12">
            <label for="doctorId" class="form-label"
              >Consulting Doctor <span class="text-danger">*</span></label
            >
            <select id="doctorId" class="form-select" formControlName="doctorId">
              <option value="" disabled>Select a doctor</option>
              @for (doctor of clinicDoctors; track doctor.doctorId) {
                <option [value]="doctor.doctorId">
                  Dr. {{ doctor.firstName }} {{ doctor.lastName }} ({{ doctor.specialization }})
                </option>
              }
            </select>
            @if (
              medicalRecordForm.get('doctorId')?.invalid &&
              medicalRecordForm.get('doctorId')?.touched
            ) {
              <div class="text-danger small mt-1">Please select a doctor.</div>
            }
          </div>

          <div class="col-md-12">
            <label for="diagnosis" class="form-label">Diagnosis</label>
            <input
              id="diagnosis"
              class="form-control"
              formControlName="diagnosis"
              placeholder="Primary diagnosis description..."
            />
          </div>

          <div class="col-md-12">
            <label for="notes" class="form-label">Clinical Notes</label>
            <textarea
              id="notes"
              class="form-control"
              formControlName="notes"
              rows="4"
              placeholder="Detailed clinical observations, treatment plans..."
            ></textarea>
          </div>

          <div class="col-md-12">
            <label for="attachments" class="form-label"
              >Attachments (Lab results, X-rays, PDFs)</label
            >
            <input
              id="attachments"
              class="form-control"
              type="file"
              (change)="onFileChange($event)"
              multiple
            />
            @if (attachments.length > 0) {
              <div class="d-flex flex-wrap gap-2 mt-2">
                @for (file of attachments; track file) {
                  <span
                    class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-2"
                  >
                    <i class="bi bi-paperclip me-1"></i>{{ file }}
                  </span>
                }
              </div>
            }
          </div>
        </div>

        @if (uploadError) {
          <div class="alert alert-danger mt-3 mb-0">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ uploadError }}
          </div>
        }

        <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
          <button
            type="submit"
            class="btn btn-primary px-4"
            [disabled]="isLoading || medicalRecordForm.invalid"
          >
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>Saving...
            } @else {
              <i class="bi bi-check2-circle me-1"></i> Save Medical Record
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
